<ion-content class="container">
  <div class="tabs-container">
    <mat-tab-group (selectedTabChange)="tabTypeChanged($event)" #tabGroup class="pt-10 pl-10 pr-10"
      [selectedIndex]="selectedTypeTabIndex" *ngIf="!router.url.includes('Setup')">
      <mat-tab label="Dashboard">
        <ng-template mat-tab-label>
          <span style="display: contents;">
            <span class="material-icons mr-10">speed</span>Dashboard
          </span>
        </ng-template>
      </mat-tab>
      <mat-tab label="Competency Master" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
        || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD'">
        <ng-template mat-tab-label>
          <span style="display: contents;">
            <span class="material-icons mr-10">group</span>Competency Master
          </span>
        </ng-template>
      </mat-tab>
      <mat-tab label="My Competency"
        *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'Employee' || loggedInUserRole == 'HOD'">
        <ng-template mat-tab-label>
          <span style="display: contents;">
            <span class="material-icons mr-10">ads_click</span>My Competency
          </span>
        </ng-template>
      </mat-tab>
      <mat-tab label="Team Competency" *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
        <ng-template mat-tab-label>
          <span style="display: contents;">
            <span class="material-icons mr-10">group</span>Team Competency
          </span>
        </ng-template>
      </mat-tab>

      <mat-tab label="Reports">
        <ng-template mat-tab-label>
          <span style="display: contents;">
            <span class="material-icons mr-10">description</span>Reports
          </span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <div *ngIf="
    (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
    || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <button type="button" class="add_btn fs-14 mr-10 float-left center-content "
            [style.background-color]="buttonColorName" (click)="onClickImportCompetency()">
            <span class="material-icons fs-20  mr-5">upload</span>
            Import
          </button>
          <button type="button" class="add_btn fs-14 float-right center-content"
            [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
            <span class="material-icons fs-20 mr-5">settings</span>Setup</button>
        </ion-col>
      </ion-row>
    </div>
    <div *ngIf="(loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD')">
      <div class="icon-container">
        <span class="material-icons mr-10 fs-16 icon">info</span>
        <div class="tooltip">
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="font_bold fs-14">Competency Settings</div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
              <span class="formLabelRegularfs12 mb-5">Fiscal Year:&nbsp;</span>
              <span class="formLabelBoldfs12">
                {{sharedService.transform(loggedInCompanyFiscalyear)}}
              </span>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
              <span class="formLabelRegularfs12 mb-5">Year:&nbsp;</span>
              <span class="formLabelBoldfs12">
                {{sharedService.transformYearToFyFormat(setUpyearRange)}}
              </span>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
              <span class="formLabelRegularfs12 mb-5">Competencies Mapped by:&nbsp;</span>
              <span class="formLabelBoldfs12">
                {{setupGradeBrand}}
              </span>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10">
              <div class="table-container">
                <table class="custom-table rounded-header">
                  <thead>
                    <tr>
                      <th class="font_semibold fs-14">Score Range</th>
                      <th class="font_semibold fs-14">Rating</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="tableData.length === 0">
                      <td colspan="3" class="text-center">No Records</td>
                    </tr>
                    <tr *ngFor="let data of tableData; let i = index">
                      <td>{{ data.scoreRange }} - {{ data.maxRange }}</td>
                      <td>{{ data.rating }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ion-col>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="5">
              <span class="formLabelRegularfs12 mb-5">Competency Evaluation Period:&nbsp;</span>
              <span class="formLabelBoldfs12">
                {{evaluationPeriod}}
              </span>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </div>
  </div>

  <!-- --------------------------------------Dashboard--------------------------------- -->

  <div class="container" *ngIf="selectedTypeTabName == 'Dashboard'  && !router.url.includes('Setup')">
    <ion-row>
      <div class="button-container mt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="display-space-between">
            <div class="verticle-center">
              <div class="d-flex">
                <mat-form-field class="w150 mat-height40 mat-input-style">
                  <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForCompetency"
                    (selectionChange)="onSelectYearForCompetencyForOther()">
                    <mat-option [value]="item.year" *ngFor="let item of compentencySetupYearList">
                      {{ sharedService.transformYearToFyFormat(item.year) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <ng-select *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'
                || loggedInUserRole == 'MD')" 
                class="w200 mat-height40 ml-5 mat-input-style"
                  [placeholder]="'Select Manager'" [clearable]="false" [(ngModel)]="selectedManagerDashboardId"
                  [items]="managerListDashboardHrAdmin" bindLabel="fullName" bindValue="id"
                  (change)="onManagerSelectedDashboardHrAdmin($event)">
                </ng-select>
                <ng-select *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'
               || loggedInUserRole == 'MD')" class="w200 mat-height40 ml-5 mat-input-style"
                  [placeholder]="'Select Employee'" [clearable]="false" [(ngModel)]="selectedEmployeeDashboardId"
                  [items]="employeelistUnderManagerGraphHrAdmin" bindLabel="fullName" bindValue="id"
                  (change)="onEmployeeSelectionChangeUnderManagerGraph($event)">
                </ng-select>

                <ng-select *ngIf="(loggedInUserRole == 'Manager'|| loggedInUserRole == 'HOD')" class="w200 mat-height40 ml-5 mat-input-style"
                  [placeholder]="'Select Employee'" [clearable]="false" placeholder="Select Employee"
                  [(ngModel)]="selectedEmployeeDashboardId" (change)="empsleectedformanagergraphview($event)">
                  <ng-option *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'" [value]="loggedInUserId">My Chart</ng-option>
                  <ng-option *ngFor="let item of employeelistUnderManager" [value]="item.id">{{item.fullName}}</ng-option>
                </ng-select>
              </div>
              <div class="d-flex competency-score-container">
                <p class="fs-12 font_semibold" *ngIf="(loggedInUserRole == 'Employee')">Employee Name: <span>{{loggedInUserName}}</span>&nbsp;|</p>
                <p class="fs-12 font_semibold" *ngIf="(loggedInUserRole == 'HOD' || loggedInUserRole == 'Manager' || loggedInUserRole == 'Employee')"> &nbsp; Manager Name:
                  <span class="fs-12 font_semibold">{{reportingManagerName?reportingManagerName:'NA'}}</span>&nbsp;|
                </p>
                <p  class="fs-12 font_semibold">&nbsp; Competency Score: <span>{{scoreForDashboard?scoreForDashboard:'NA'}}</span>&nbsp;|</p>
                <p  class="fs-12 font_semibold"> &nbsp; Rating: <span>{{competencyRatingDashboard?competencyRatingDashboard:'NA'}}</span></p>
              </div>
            </div>
            <!-- <div>
              <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span>
            </div> -->
          </div>
        </ion-col>
      </div>
    </ion-row>

    <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'
    || loggedInUserRole == 'MD'">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="cardBoxList">
            <div class="cardBoxGraph">
              <div class="font_regular mt-0 fs-14 black_color">Total No. of Dept/Function</div>
              <div class="font_semibold pt-6 fs-14 text_green">{{ functionsCount }}</div>
            </div>
            <div class="cardBoxGraph">
              <div class="font_regular mt-0 fs-14 black_color">Total No. of {{setupGradeBrand}}</div>
              <div class="font_semibold pt-6 fs-14 Cerulean-Blue">{{ bandsCount }}</div>
            </div>
            <div class="cardBoxGraph">
              <div class="font_regular mt-0 fs-14 black_color">Total Published Comp.</div>
              <div class="font_semibold pt-6 fs-14 yellow">{{ totalPublishComp }}</div>
            </div>
            <div class="cardBoxGraph cp" (click)="onClickCompetencyCard('Competency Set')">
              <div class="font_regular mt-0 fs-14 black_color">Competency Set</div>
              <div class="font_semibold pt-6 fs-14 Cerulean-Blue">{{ competenciesSet }}</div>
            </div>
            <div class="cardBoxGraph cp" (click)="onClickCompetencyCard('Evaluated by Manager')">
              <div class="font_regular mt-0 fs-14 black_color">Evaluated by Manager</div>
              <div class="font_semibold pt-6 fs-14 text-blue-violet">{{ evaluatedCompetencies }}</div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
    <!-- this.loggedInUserId, -->
    <div class="pt-15">
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs m-50">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Weightage wise Competencies</div>
                  <div class="d-flex graph-icon">
                    <span (click)="switchWeightageWiseCompetenciesGraphType('bar')">
                      <img *ngIf="weightageWiseCompetenciesGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg"
                        alt="">
                      <img *ngIf="weightageWiseCompetenciesGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg"
                        alt="">
                    </span>
                    <span (click)="switchWeightageWiseCompetenciesGraphType('pie')">
                      <img *ngIf="weightageWiseCompetenciesGraphType != 'pie'" src="././assets/icon/pieChartIcon.svg"
                        alt="">
                      <img *ngIf="weightageWiseCompetenciesGraphType == 'pie'" src="././assets/icon/PieIconActive.svg"
                        alt="">
                    </span>
                    <span (click)="onClickTableWeightageWiseCompetencies()">
                      <img *ngIf="!showWeightagewiseCompetenciesTable" src="././assets/icon/tableIcon.svg" alt="">
                      <img *ngIf="showWeightagewiseCompetenciesTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchWeightageWiseCompetenciesGraphType('line')">
                      <img *ngIf="weightageWiseCompetenciesGraphType != 'line'" src="././assets/icon/lineChartIcon.svg"
                        alt="">
                      <img *ngIf="weightageWiseCompetenciesGraphType == 'line'"
                        src="././assets/icon/activeLineChart.svg" alt="">
                    </span>
                    <span (click)="downloadWeightageWiseCompetenciesGraph()"><img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size-sm="8" size-md="4" size-lg="4" size-xs="8">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphOneHRAdmin"
                      (selectionChange)="onSelectYearForGraphOneHrAdmin()">
                      <mat-option [value]="item.year" *ngFor="let item of compentencySetupYearList">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : showWeightagewiseCompetenciesTable}">
              <div id="WeightageWiseCompetenciesGraphs" style="width: 100%; height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !showWeightagewiseCompetenciesTable}" id="WeightageWiseCompetenciesTable">
              <ion-row class="mt-5">
                <ion-col size="12">
                  <table class="employee-table">
                    <thead>
                      <tr>
                        <th>Competency Name</th>
                        <th>WT</th>
                        <th>Score</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of weightageWiseCompetenciesGraphData">
                        <td>{{ item.competencyName }}</td>
                        <td>{{ item.wt }}</td>
                        <td>{{ item.score }}</td>
                      </tr>
                    </tbody>
                  </table>
                </ion-col>
              </ion-row>
            </div>
          </div>
        </ion-col>

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Top and Bottom Competency by score</div>
                  <div class="d-flex graph-icon">
                    <span (click)="switchTandBCompetencyScoreGraphType('bar')">
                      <img *ngIf="TopandBottonCompetencyByScoreGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg"
                        alt="">
                      <img *ngIf="TopandBottonCompetencyByScoreGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg"
                        alt="">
                    </span>
                    <span (click)="switchTandBCompetencyScoreGraphType('line')">
                      <img *ngIf="TopandBottonCompetencyByScoreGraphType != 'line'"
                        src="././assets/icon/lineChartIcon.svg" alt="">
                      <img *ngIf="TopandBottonCompetencyByScoreGraphType == 'line'"
                        src="././assets/icon/activeLineChart.svg" alt="">
                    </span>
                    <span (click)="switchTandBCompetencyScoreGraphType('scatter')">
                      <img *ngIf="TopandBottonCompetencyByScoreGraphType != 'scatter'"
                        src="././assets/icon/inActiveScatter.svg" alt="">
                      <img *ngIf="TopandBottonCompetencyByScoreGraphType == 'scatter'"
                        src="././assets/icon/ActiveScatter.svg" alt="">
                    </span>
                    <span (click)="downloadTopAndBottomByScoreGraph()">
                      <img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size-sm="6" size-md="4" size-lg="4" size-xs="6">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphTwoHRAdmin"
                      (selectionChange)="onSelectYearForGraphTwoHrAdmin()">
                      <mat-option [value]="item.year" *ngFor="let item of compentencySetupYearList">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="6" size-md="8" size-lg="8" size-xs="6">
                  <mat-radio-group [(ngModel)]="selectedOption" (ngModelChange)="onOptionChange($event)"
                    aria-label="Select an option" class="ml-35">
                    <mat-radio-button class="fs-12 font_regular" value="Top">Top</mat-radio-button>
                    <mat-radio-button class="fs-12 font_regular" value="Bottom">Bottom</mat-radio-button>
                  </mat-radio-group>
                </ion-col>
              </ion-row>
            </div>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div id="topBottomGraph" style="width: 100%; height: 400px;"></div>
              </ion-col>
            </ion-row>
            <!-- <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_regular fs-10 text-center"> Achieved Competency</div>
              </ion-col>
            </ion-row> -->
          </div>
        </ion-col>
      </ion-row>
    </div>
    <div class="pt-15">
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs m-50">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Competency wise Year on Year Score</div>
                  <div class="d-flex graph-icon">
                    <span (click)="switchCompetencyYearOnYearGraphType('bar')">
                      <img *ngIf="CompetencyYearOnYearGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="CompetencyYearOnYearGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                    </span>
                    <span (click)="switchCompetencyYearOnYearGraphType('line')">
                      <img *ngIf="CompetencyYearOnYearGraphType != 'line'" src="././assets/icon/lineChartIcon.svg"
                        alt="">
                      <img *ngIf="CompetencyYearOnYearGraphType == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="downloadCompetencyWiseYearScoreGraph()">
                      <img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size-sm="8" size-md="4" size-lg="4" size-xs="8">
                  <ng-select [clearable]="false" class="w-100 mat-height40 ml-5 mat-input-style"
                    [items]="SelectCompetencyDropdownListForGraph" bindLabel="itemName" bindValue="id" [placeholder]="'Select Competency'"
                    [(ngModel)]="selectedCompetencyForEmployeeDashboard" (change)="onCompetencyChange($event)">
                  </ng-select>
                </ion-col>
              </ion-row>
              <ion-row>
              </ion-row>
            </div>
            <div id="CompetencyWiseYearScore" style="width: 100%; height: 400px;"></div>
          </div>
        </ion-col>

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Competency Trend</div>
                  <div class="d-flex graph-icon">
                    <span (click)="switchCompetencyTrendGraphType('bar')">
                      <img *ngIf="CompetencyTrendGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="CompetencyTrendGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                    </span>
                    <span (click)="switchCompetencyTrendGraphType('line')">
                      <img *ngIf="CompetencyTrendGraphType != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                      <img *ngIf="CompetencyTrendGraphType == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                    </span>
                    <span (click)="switchCompetencyTrendGraphType('scatter')">
                      <img *ngIf="CompetencyTrendGraphType != 'scatter'" src="././assets/icon/inActiveScatter.svg"
                        alt="">
                      <img *ngIf="CompetencyTrendGraphType == 'scatter'" src="././assets/icon/ActiveScatter.svg" alt="">
                    </span>
                    <span (click)="downloadCompetencyTrendGraph()">
                      <img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
              <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                </ion-col>
              </ion-row>
            </div>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div id="CompetencyTrend" style="width: 100%; height: 400px;"></div>
              </ion-col>
            </ion-row>
            <!-- <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_regular fs-10 text-center">Competency</div>
              </ion-col>
            </ion-row> -->
          </div>
        </ion-col>
      </ion-row>
    </div>
    <div class="pt-20 pb-5">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="text-center" *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin'
          || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Manager'">
            <h2 class="font_bold fs-22">Team Overview</h2>
          </div>
        </ion-col>
      </ion-row>
    </div>

    <!-- //team Graphs -->
    <div class="pt-15" *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin'
    || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Manager'">
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs m-50">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Competency Wise Employee</div>
                  <div class="d-flex graph-icon">
                    <!-- <span (click)="switchCompetencyWiseEmployeeGraphType('bar')">
                      <img *ngIf="CompetencyWiseEmployeeGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg"
                        alt="">
                      <img *ngIf="CompetencyWiseEmployeeGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg"
                        alt="">
                    </span> -->
                    <!-- <span (click)="switchCompetencyWiseEmployeeGraphType('pie')">
                      <img *ngIf="CompetencyWiseEmployeeGraphType != 'pie'" src="././assets/icon/pieChartIcon.svg"
                        alt="">
                      <img *ngIf="CompetencyWiseEmployeeGraphType == 'pie'" src="././assets/icon/PieIconActive.svg"
                        alt="">
                    </span> -->
                    <span (click)="onClickTableCompetencyWiseEmployee()">
                      <img *ngIf="!showCompetencyWiseEmployeeTble" src="././assets/icon/tableIcon.svg" alt="">
                      <img *ngIf="showCompetencyWiseEmployeeTble" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <!-- <span (click)="switchCompetencyWiseEmployeeGraphType('line')">
                      <img *ngIf="CompetencyWiseEmployeeGraphType != 'line'" src="././assets/icon/lineChartIcon.svg"
                        alt="">
                      <img *ngIf="CompetencyWiseEmployeeGraphType == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span> -->
                    <span (click)="downloadCompetencyWiseEmpGraph()"><img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-5"> <!-- Adjusted margin-bottom -->
              <!-- Controls for selecting year and competency -->
              <ion-row>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphFifthHRAdmin"
                      (selectionChange)="onSelectYearForGraphFifthHrAdmin()">
                      <mat-option [value]="item.year" *ngFor="let item of compentencySetupYearList">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <ng-select [clearable]="false" class="w-100 mat-height40 mat-input-style"
                    [items]="SelectCompetencyDropdownListForEmployeeTableTeamGraphView"
                    bindLabel="itemName" bindValue="id"
                    [placeholder]="'Select Competency'" [(ngModel)]="selectedCompetencyForEmployeeTableTeamGraphView"
                    (change)="onCompetencyChangeForTeamGraphOne($event)">
                  </ng-select>
                </ion-col>
              </ion-row>
              <div [ngClass]="{'dispNone' : showCompetencyWiseEmployeeTble}">
                <!-- <div id="CompetencyWiseEmployee" style="width: 100%; height: 400px;"></div> -->
              </div>
              <div [ngClass]="{'dispNone' : !showCompetencyWiseEmployeeTble}" id="competencyWiseEmployeeTable">
                <ion-row class="mt-5">
                  <ion-col size="12">
                    <table class="employee-table">
                      <thead>
                        <tr>
                          <th>Employee Name</th>
                          <th>WT</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of graphDataForCompetencyWiseEmployee">
                          <td>{{ item.empName }}</td>
                          <td>{{ item.wt }}</td>
                          <td>{{ item.score }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </div>
        </ion-col>

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Rating-wise Employee count</div>
                  <div class="d-flex graph-icon">
                    <span (click)="switchRatingWiseEmployeeCountGraphType('bar')">
                      <img *ngIf="RatingWiseEmployeeCountGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg"
                        alt="">
                      <img *ngIf="RatingWiseEmployeeCountGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg"
                        alt="">
                    </span>
                    <span (click)="switchRatingWiseEmployeeCountGraphType('pie')">
                      <img *ngIf="RatingWiseEmployeeCountGraphType != 'pie'" src="././assets/icon/pieChartIcon.svg"
                        alt="">
                      <img *ngIf="RatingWiseEmployeeCountGraphType == 'pie'" src="././assets/icon/PieIconActive.svg"
                        alt="">
                    </span>
                    <span (click)="onClickTableRatingWiseEmp()">
                      <img *ngIf="!showRatingWiseEmpTble" src="././assets/icon/tableIcon.svg" alt="">
                      <img *ngIf="showRatingWiseEmpTble" src="././assets/icon/activeTable.svg" alt="">
                    </span>
                    <span (click)="switchRatingWiseEmployeeCountGraphType('line')">
                      <img *ngIf="RatingWiseEmployeeCountGraphType != 'line'" src="././assets/icon/lineChartIcon.svg"
                        alt="">
                      <img *ngIf="RatingWiseEmployeeCountGraphType == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="switchRatingWiseEmployeeCountGraphType('scatter')">
                      <img *ngIf="RatingWiseEmployeeCountGraphType != 'scatter'"
                        src="././assets/icon/inActiveScatter.svg" alt="">
                      <img *ngIf="RatingWiseEmployeeCountGraphType == 'scatter'" src="././assets/icon/ActiveScatter.svg"
                        alt="">
                    </span>

                    <span (click)="downloadRatingWiseEmpcountGraph()"><img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-5"> <!-- Adjusted margin-bottom -->
              <ion-row>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <mat-form-field class="w-35 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphSix"
                      (selectionChange)="onSelectYearForGraphSixHrAdmin()">
                      <mat-option [value]="item.year" *ngFor="let item of compentencySetupYearList || []">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>
              </ion-row>
            </div>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div [ngClass]="{'dispNone' : showRatingWiseEmpTble}" id="ratingWiseEmployeeCount" style="width: 100%; height: 400px;"></div>
                <div [ngClass]="{'dispNone' : !showRatingWiseEmpTble}" id="ratingWiseEmployeeCountTable">
                  <ion-row class="mt-5">
                    <ion-col size="12">
                      <table class="employee-table">
                        <thead>
                          <tr>
                            <th>Rating</th>
                            <th>No. of Employees</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of graphDataForRatingWiseEmployeeCount">
                            <td>{{ item.rating }}</td>
                            <td>{{ item.empCount }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </ion-col>
                  </ion-row>
                </div>
              </ion-col>
            </ion-row>
            <!-- <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_regular fs-10 text-center">Ratings</div>
              </ion-col>
            </ion-row> -->
          </div>
        </ion-col>
      </ion-row>
    </div>

    <!-- //last 2 graphs hr admin -->
    <div class="pt-15" *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin'
    || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Manager'">
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs m-50">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="5" size-xs="12">
                <div class="fs-14 font_semibold">Comparison Employee wise</div>
              </ion-col>
              <ion-col size-sm="12" size-md="12" size-lg="7" size-xs="12" class="text-right">
                <div class="d-flex graph-icon">
                  <span (click)="switchComparisonEmployeeWiseGraphType('bar')">
                    <img *ngIf="ComparisonEmployeeWiseGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                    <img *ngIf="ComparisonEmployeeWiseGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg"
                      alt="">
                  </span>
                  <span (click)="switchComparisonEmployeeWiseGraphType('pie')">
                    <img *ngIf="ComparisonEmployeeWiseGraphType != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                    <img *ngIf="ComparisonEmployeeWiseGraphType == 'pie'" src="././assets/icon/PieIconActive.svg"
                      alt="">
                  </span>
                  <span (click)="onClickTableComparisonEmployeeWise()">
                    <img *ngIf="!showComparisonEmployeeWiseTble" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="showComparisonEmployeeWiseTble" src="././assets/icon/TableIconActive.svg" alt="">
                  </span>
                  <span (click)="switchComparisonEmployeeWiseGraphType('line')">
                    <img *ngIf="ComparisonEmployeeWiseGraphType != 'line'" src="././assets/icon/lineChartIcon.svg"
                      alt="">
                    <img *ngIf="ComparisonEmployeeWiseGraphType == 'line'" src="././assets/icon/activeLineChart.svg"
                      alt="">
                  </span>
                  <span (click)="switchComparisonEmployeeWiseGraphType('scatter')">
                    <img *ngIf="ComparisonEmployeeWiseGraphType != 'scatter'" src="././assets/icon/inActiveScatter.svg"
                      alt="">
                    <img *ngIf="ComparisonEmployeeWiseGraphType == 'scatter'" src="././assets/icon/ActiveScatter.svg"
                      alt="">
                  </span>
                  <span (click)="downloadComparisonEmpWiseGraph()"><img src="././assets/icon/downloadIcon.svg" alt="">
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-5">
              <!-- <ion-row> -->
                <div class="center-content">
                  <mat-form-field class="w150 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphNineHRAdmin"
                      (selectionChange)="onSelectYearForGraphNineHrAdmin()">
                      <mat-option [value]="item.year" *ngFor="let item of compentencySetupYearList">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                <!-- </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4"> -->
                  <ng-select [items]="ComparisonEmployeeWiseList" bindLabel="competenyName" 
                  bindLabel="itemName" bindValue="id" [clearable]="false" [(ngModel)]="selectedCompetencyName"
                    class="w150 mat-height40 ml-5 mat-input-style" (change)="onCompSelect($event)">
                  </ng-select>
                <!-- </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4"> -->
                  <ng-multiselect-dropdown class="ml-5 w250"
                  [placeholder]="'Select Employee'" [settings]="dropdownSettings" [data]="employeesListComparisonSelected"
                  [(ngModel)]="comparisonEmployeesSelectMultiple" (onSelect)="getComparisonEmployeeWiseGraph()"
                  (onDeSelect)="getComparisonEmployeeWiseGraph()" (onSelectAll)="onSelectAllComparisonEmployeeWise($event)"
                  (onDeSelectAll)="onDeselectAllComparisonEmployeeWise()">
                </ng-multiselect-dropdown>
                  <!-- <ng-select class="ml-5 w-100" [clearable]="false" [placeholder]="'Select Employee'"
                    [items]="employeesListComparisonSelected" bindLabel="itemName" bindValue="id"
                    [(ngModel)]="comparisonEmployeesSelectMultiple"
                    (change)="onComparisonEmpSelect($event)">
                  </ng-select> -->
                <!-- </ion-col>
              </ion-row> -->
              </div>
              <div [ngClass]="{'dispNone' : showComparisonEmployeeWiseTble}">
                <div id="comparisonEmployeewiseGraph" style="width: 100%; height: 400px;"></div>
              </div>
              <div [ngClass]="{'dispNone' : !showComparisonEmployeeWiseTble}" id="comparisonEmployeewiseTable">
                <ion-row class="mt-5">
                  <ion-col size="12">
                    <table class="employee-table">
                      <thead>
                        <tr>
                          <th>Emp Name</th>
                          <th>WT</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of graphDataForComparisonEmployeeWise">
                          <td>{{ item.empName }}</td>
                          <td>{{ item.wt }}</td>
                          <td>{{ item.score }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </div>
        </ion-col>

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Year On Year Final Score</div>
                  <div class="d-flex graph-icon">
                    <span (click)="switchYearOnYearFinalScoreGraphType('bar')">
                      <img *ngIf="YearOnYearFinalScoreGraphType != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="YearOnYearFinalScoreGraphType == 'bar'" src="././assets/icon/BarGraphActive.svg"
                        alt="">
                    </span>
                    <span (click)="switchYearOnYearFinalScoreGraphType('pie')">
                      <img *ngIf="YearOnYearFinalScoreGraphType != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                      <img *ngIf="YearOnYearFinalScoreGraphType == 'pie'" src="././assets/icon/PieIconActive.svg"
                        alt="">
                    </span>
                    <span (click)="onClickTableYearOnYearFinalScore()">
                      <img *ngIf="!showYearOnYearFinalScoreTble" src="././assets/icon/tableIcon.svg" alt="">
                      <img *ngIf="showYearOnYearFinalScoreTble" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchYearOnYearFinalScoreGraphType('line')">
                      <img *ngIf="YearOnYearFinalScoreGraphType != 'line'" src="././assets/icon/lineChartIcon.svg"
                        alt="">
                      <img *ngIf="YearOnYearFinalScoreGraphType == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="switchYearOnYearFinalScoreGraphType('scatter')">
                      <img *ngIf="YearOnYearFinalScoreGraphType != 'scatter'" src="././assets/icon/inActiveScatter.svg"
                        alt="">
                      <img *ngIf="YearOnYearFinalScoreGraphType == 'scatter'" src="././assets/icon/ActiveScatter.svg"
                        alt="">
                    </span>
                    <span (click)="downloadYearFinalScoreGraph()"><img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-5 center-content">
              <mat-form-field class="w150 mat-height40 mat-input-style">
                <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphTenHRAdmin"
                  (selectionChange)="onSelectYearForGraphTenHrAdmin()">
                  <mat-option [value]="item.year" *ngFor="let item of compentencySetupYearList">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <ng-multiselect-dropdown class="ml-5 w250"
              [placeholder]="'Select Employee'" [settings]="dropdownSettings" [data]="yearOnYearEmployeesFinal"
              [(ngModel)]="selectedEmpYearonYear" (onSelect)="YearOnYearFinalScoreGraph()"
              (onDeSelect)="YearOnYearFinalScoreGraph()" (onSelectAll)="onSelectAllYearOnYearFinalScore($event)"
              (onDeSelectAll)="onDeselectAllYearOnYearFinalScore()">
            </ng-multiselect-dropdown>
              <!-- <ion-row>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">

                </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">

                  <ng-select [items]="yearOnYearEmployeesFinal" bindLabel="fullName" bindValue="id"
                    [(ngModel)]="selectedEmpYearonYear" (change)="logSelectedEmployee()" [clearable]="false"
                    class="w-100 mat-height40 ml-5 mat-input-style">
                  </ng-select>
                </ion-col>
              </ion-row> -->
            </div>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div [ngClass]="{'dispNone' : showYearOnYearFinalScoreTble}">
                  <div id="YearOnYearScore" style="width: 100%; height: 400px;"></div>
                </div>
                <div [ngClass]="{'dispNone' : !showYearOnYearFinalScoreTble}" id="YearOnYearScoreTable">
                  <ion-row class="mt-5">
                    <ion-col size="12">
                      <table class="employee-table">
                        <thead>
                          <tr>
                            <th>Emp Name</th>
                            <th>Score</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of graphDataForYearOnYearFinalScore">
                            <td>{{ item.employeeName }}</td>
                            <td>{{ item.score }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </ion-col>
                  </ion-row>
                </div>
              </ion-col>
            </ion-row>
            <!-- <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_regular fs-10 text-center">Ratings</div>
              </ion-col>
            </ion-row> -->
          </div>
        </ion-col>
      </ion-row>
    </div>


    <!-- Manager vIew Graphs -->
    <!-- <div class="pt-15" *ngIf="(loggedInUserRole == 'Manager')">
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs m-50">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Competency Wise Employee</div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-5">
              <ion-row>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <mat-form-field class="w-35 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForMnagerGraphCompetencyWiseEmp"
                      (selectionChange)="onSelectYearForManagerGraphCompetencyWise()">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <ng-select [clearable]="false" class="w-100 mat-height40 ml-5 mat-input-style"
                    [items]="managerEmpGraphListView" bindLabel="competencyName" bindValue="id"
                    [placeholder]="'Select Competency'" [(ngModel)]="selectedManagerGraphEmpId"
                    (ngModelChange)="selectManagerGraphViewEmp($event)">
                  </ng-select>
                </ion-col>
              </ion-row>
              <ion-row class="mt-5">
                <ion-col size="12">
                  <table class="employee-table">
                    <thead>
                      <tr>
                        <th>Emp Name</th>
                        <th>WT</th>
                        <th>Score</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of managerEmpGraphTableData">
                        <td>{{ item.empName }}</td>
                        <td>{{ item.wt }}</td>
                        <td>{{ item.score }}</td>
                      </tr>
                    </tbody>
                  </table>
                </ion-col>
              </ion-row>
            </div>
          </div>
        </ion-col>

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Rating-wise Employee count</div>
                  <div class="d-flex graph-icon">
                    <span><img src="././assets/icon/activeTable.svg" alt=""></span>
                    <span><img src="././assets/icon/lineChartIcon.svg" alt=""></span>
                    <span><img src="././assets/icon/downloadIcon.svg" alt=""></span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-5">
              <ion-row>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <mat-form-field class="w-35 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphManagerViewRatingWise"
                      (selectionChange)="onSelectYearForGraphManagerViewRatingWise()">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </div>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div id="CompetencyGraphRatingwiseManagerView" style="width: 100%; height: 400px;"></div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_regular fs-10 text-center">Ratings</div>
              </ion-col>
            </ion-row>
          </div>
        </ion-col>
      </ion-row>
    </div> -->


    <!-- Second Last Graph Manager View-->

    <!-- <div class="pt-15" *ngIf="(loggedInUserRole == 'Manager')">
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs m-50">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Comparison Employee wise</div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-5">
              <ion-row>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <mat-form-field class="w-35 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphMangerViewComparison"
                      (selectionChange)="onSelectYearForGraphManagerViewComparison()">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <ng-select 
                  [items]="ComparisonEmployeeWiseListManagerViewData" 
                  bindLabel="competenyName"
                  [clearable]="false" 
                  class="w-100 mat-height40 ml-5 mat-input-style"
                  (change)="onCompSelectManagerView($event)">
                </ng-select>
                
                </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <ng-select 
                  [items]="employeesListComparisonSelectedManagerView" 
                  bindLabel="itemName"
                  [clearable]="false" 
                  [multiple]="true" 
                  class="ml-5 w-100"
                  (change)="onComparisonEmpSelectManagerView($event)">
                </ng-select>
                
                </ion-col>
              </ion-row>
              <ion-row class="mt-5">
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  <div id="ComparisionManagerView" style="width: 100%; height: 400px;"></div>
                </ion-col>
              </ion-row>
            </div>
          </div>
        </ion-col>

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="graph-title">
                  <div class="fs-14 font_semibold">Year On Year Final Score</div>
                  <div class="d-flex graph-icon">
                    <span><img src="././assets/icon/activeTable.svg" alt=""></span>
                    <span><img src="././assets/icon/lineChartIcon.svg" alt=""></span>
                    <span><img src="././assets/icon/downloadIcon.svg" alt=""></span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-5">
              <ion-row>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <mat-form-field class="w-35 mat-height40 mat-input-style">
                    <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForGraphTenHRAdmin"
                      (selectionChange)="onSelectYearForGraphTenHrAdmin()">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <ng-select [items]="yearOnYearEmployeesFinal" bindLabel="fullName" bindValue="id"
                    [(ngModel)]="selectedEmpYearonYear" (change)="logSelectedEmployee()" [clearable]="false"
                    class="w-100 mat-height40 ml-5 mat-input-style">
                  </ng-select>
                </ion-col>
              </ion-row>
            </div>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div id="YearOnYear" style="width: 100%; height: 400px;"></div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="font_regular fs-10 text-center">Ratings</div>
              </ion-col>
            </ion-row>
          </div>
        </ion-col>
      </ion-row>
    </div> -->

  </div>

  <!-- --------------------------------------Competency Master--------------------------------- -->

  <div class="container"
    *ngIf="selectedTypeTabName === 'Competency Master' || selectedTypeTabName === 'My Competency' || selectedTypeTabName === 'Team Competency'">
    <button (click)="CronJob()" *ngIf="selectedTypeTabName === 'Competency Master'" type="button" class="add_btn fs-14 mr-10"
      [style.background-color]="buttonColorName">
      Cron Job
    </button>
    <div class="button-container mt-15">
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
        class="text-left display-start d-flex align-items-center">
        <mat-form-field class="w-35 mat-height40 mat-input-style">
          <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForCompetency"
            (selectionChange)="onSelectYearForCompetencyForOther()">
            <mat-option [value]="item.year" *ngFor="let item of compentencySetupYearList">
              {{ sharedService.transformYearToFyFormat(item.year) }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-select class="w-30 mat-height40 ml-5 mat-input-style" *ngIf="selectedTypeTabName == 'Team Competency'"
          [placeholder]="'Select Employee'" [clearable]="false" [(ngModel)]="selectedEmployeeId"
          (change)="getCompetencyByManagerTeamList()">
          <ng-option [value]="item.id" *ngFor="let item of employeelistUnderManager">{{item.fullName}}</ng-option>
        </ng-select>
      </ion-col>


      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="text-right display-end">
        <button *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'Employee'" type="button"
          class="pms_btn center-content fs-14 ml-5 bydefaultspan">
          <span class="black_color">
            The target is set to <span style="color: #F2810A;">100</span> by default.
          </span>
        </button>
        <button *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
          || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD'" type="button"
          class="pms_btn center-content fs-14 ml-5">
          <span class="displayContent" (click)="competencyDictionaryPopup()">
            <span class="material-icons fs-20 mr-5">book</span>
            Competency Dictionary
          </span>
        </button>
      </ion-col>
    </div>
    <div class="tableCardBox mb-15 mt-10">
      <ion-row>
        <ion-col size-sm="7" size-md="7" size-lg="7" size-xs="7">
          <div class="d-flex align-items-center">
            <div *ngIf="selectedItemsForPublish.size>0 || selectedItemsForDelete.size>0">
              <button (click)="deleteCompetency()" class="materialBtnIcon red fs-14 font_semibold mr-15">
                <span class="material-icons fs-20">delete</span>
              </button>
              <button (click)="publish()" type="button" class="bluecolor add_btn_two fs-14 float-right center-content">
                <span class="material-icons fs-20 mr-5 bluecolor">settings_input_composite</span>Publish
              </button>
            </div>
            <mat-form-field *ngIf="!anyItemSelected" class="mat-height40 mat-input-style">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search" [(ngModel)]="searchString"
                (input)="onSearch(searchString)">
            </mat-form-field>
            <ion-label class="fs-14 ml-10 mt-10 font_medium text-center black_color">Show</ion-label>
            <mat-form-field class="w-15 ml-10 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedSizeOfPMS"
                (selectionChange)="onSelectSizeOfCompetency()">
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 ml-10 mt-10 font_medium black_color">entries</ion-label>
          </div>
        </ion-col>
        <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5">
          <div class="d-flex float-right">
            <button type="button" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'
            || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') && isShowAddBtn"
              class="add_btn fs-14 mr-15" [style.background-color]="buttonColorName" (click)="addNewCompetency()">
              Add New
            </button>
            <button class="materialBtnIcon black_color fs-14 font_semibold mr-15" (click)="downloadData()">
              <span class="material-icons">download</span>
            </button>
            <!-- <button [matMenuTriggerFor]="menu" [style.background-color]="buttonColorName"
              class="customMaterialIcon fs-14">
              <span class="material-icons">tune</span>
            </button> -->
            <mat-menu #menu="matMenu">
              <ion-row>
                <ion-col size="6" class="mat-checkbox-style">
                  <mat-checkbox [(ngModel)]="columnVisibility['function']">
                    Dept/Function
                  </mat-checkbox>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <button type="button" class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName"
                    (click)="applyFilters()">
                    Apply
                  </button>
                </ion-col>
              </ion-row>
            </mat-menu>
          </div>
        </ion-col>
      </ion-row>

      <!-- hr admin view -->
      <ion-row class="p-0 mt-5"
        *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD'">
        <div class="table-container">
          <table class="hover mb-5 custom-table">
            <thead>
              <tr>
                <th class="mat-checkbox-style" *ngIf="allowedToEditDelete">
                  <mat-checkbox class="custom-checkbox" (change)="selectALLRecords($event)"
                    [(ngModel)]="selectAllCheckbox" [checked]="selectAllCheckbox==true"></mat-checkbox>
                </th>
                <th *ngIf="columnVisibility['function']" class="fs-14 font_bold cl-black">
                  Dept/Function
                  <!-- <span class="material-icons cp ml-5 mt-3 fs-14"
                    (click)="toggleVisibility('function')">visibility_off</span> -->
                </th>
                <th *ngIf="columnVisibility['band']" class="fs-14 font_bold cl-black">
                  {{setupGradeBrand}}
                  <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                </th>
                <th *ngIf="columnVisibility['competencyName']" class="fs-14 font_bold cl-black competency-name-column">
                  Competency Name
                  <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                </th>
                <th *ngIf="columnVisibility['competencyDefinition']"
                  class="fs-14 font_bold cl-black competency-definition-column">
                  Competency Defination
                  <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                </th>
                <th *ngIf="columnVisibility['weightage']" class="fs-14 font_bold cl-black wt-column">
                  WT
                  <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                </th>
                <th *ngIf="columnVisibility['publishedOn']" class="fs-14 font_bold cl-black">
                  Published on
                  <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                </th>
                <th *ngIf="columnVisibility['createdBy']" class="fs-14 font_bold cl-black">
                  Created By
                  <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                </th>
                <th *ngIf="columnVisibility['lastModifiedBy']" class="fs-14 font_bold cl-black">
                  Last Modified By
                  <!-- <span class="material-icons cp ml-5 mt-3 fs-14">visibility_off</span> -->
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of hradminCompetency;let i = index">
                <ng-container *ngFor="let competency of item.competencyMasterlist">
                  <tr>
                    <td class="mat-checkbox-style" *ngIf="competency === item.competencyMasterlist[0] &&
                    !item.allowedToEditDelete && !item.published"
                      [attr.rowspan]="item.competencyMasterlist.length">
                      <mat-checkbox class="custom-checkbox" [(ngModel)]="item.checkboxCheck" [value]="item.id"
                        (change)="selectSingleRecord($event, item,i)" [disabled]="item.allowedToEditDelete"></mat-checkbox>
                    </td>
                    <td *ngIf="competency === item.competencyMasterlist[0] &&
                    !item.allowedToEditDelete && item.published"
                      [attr.rowspan]="item.competencyMasterlist.length">
                    </td>
                    <td *ngIf="competency === item.competencyMasterlist[0]" class="fs-14 font_regular"
                      [attr.rowspan]="item.competencyMasterlist.length">
                      <ng-select *ngIf="!item.allowedToEditDelete" dropdownPosition="bottom" placeholder="Select Dept/Function"
                        [(ngModel)]="item.functionName" (change)="onFunctionChange($event,item,i)" [clearable]="false"
                        (selectionChange)="hradmincompetencyeditandsave(item,i)">
                        <ng-option *ngFor="let func of getListOfDepartmentsOfComp" [value]="func.id">
                          {{ func.itemName }}
                        </ng-option>
                      </ng-select>
                      <span *ngIf="item.allowedToEditDelete" class="fs-14 font_regular">{{item.functionName}}</span>
                    </td>
                    <td *ngIf="competency === item.competencyMasterlist[0]" class="fs-14 font_regular"
                      [attr.rowspan]="item.competencyMasterlist.length">
                      <ng-select *ngIf="!item.allowedToEditDelete" dropdownPosition="bottom" placeholder="Select Band" [clearable]="false"
                        [(ngModel)]="item.band" (change)="onBandSelectionChange($event);hradmincompetencyeditandsave(item,i)">
                        <ng-option *ngFor="let band of bandListHrAdmin" [value]="band">
                          {{ band }}
                        </ng-option>
                      </ng-select>
                      <span *ngIf="item.allowedToEditDelete" class="fs-14 font_regular">{{item.band}}</span>
                    </td>
                    <td *ngIf="columnVisibility['competencyName']" class="fs-14 font_regular competency-name-column">
                      <textarea *ngIf="!item.allowedToEditDelete" [(ngModel)]="competency.competencyName" (ngModelChange)="uniqueCompetencyValidator(item,i);checkLengthOfField(competency.competencyName)" 
                        (blur)="hradmincompetencyeditandsave(item,i)"
                        rows="2" class="competency-textarea" maxlength="255"></textarea>
                      <span *ngIf="item.allowedToEditDelete" class="fs-14 font_regular">{{competency.competencyName}}</span>
                    </td>
                    <td *ngIf="columnVisibility['competencyDefinition']"
                      class="fs-14 font_regular competency-definition-column">
                      <textarea *ngIf="!item.allowedToEditDelete" [(ngModel)]="competency.competencyDefination" (ngModelChange)="uniqueCompetencyValidator(item,i);checkLengthOfField(competency.competencyDefination)"
                        (blur)="hradmincompetencyeditandsave(item,i)" maxlength="255" class="competency-textarea borderNone"></textarea>
                        <textarea *ngIf="item.allowedToEditDelete" maxlength="255" readonly [(ngModel)]="competency.competencyDefination" class="competency-textarea"></textarea>
                      </td>
                    <td *ngIf="columnVisibility['weightage']" class="fs-14 font_regular wt-column">
                      <input *ngIf="!item.allowedToEditDelete" type="number" [(ngModel)]="competency.weightageNo" class="wt-input" min="0"
                        (input)="onWeightageChange(item,i)" maxlength="255"/>
                      <span *ngIf="item.allowedToEditDelete" class="fs-14 font_regular">{{competency.weightageNo}}</span>
                    </td>
                    <td *ngIf="competency === item.competencyMasterlist[0]" class="fs-14 font_regular"
                      [attr.rowspan]="item.competencyMasterlist.length">
                      {{ item.formattedPublishedOn }}
                    </td>
                    <td *ngIf="competency === item.competencyMasterlist[0]" class="fs-14 font_regular"
                      [attr.rowspan]="item.competencyMasterlist.length">
                      {{ item.createdBy }} <br>{{ item.formattedCreatedAt }}
                    </td>
                    <td *ngIf="competency === item.competencyMasterlist[0]" class="fs-14 font_regular"
                      [attr.rowspan]="item.competencyMasterlist.length">
                      {{ item.lastModifiedBy }} <br>{{ item.formattedLastModifiedOn }}
                    </td>
                  </tr>
                </ng-container>
                <tr class="total-row">
                  <td colspan="1" *ngIf="!item.allowedToEditDelete"></td>
                  <td colspan="2" class="fs-14 font_bold cl-black text-right">
                    <span *ngIf="indexOfErrMsgDuplicateDeptandBand==i && errMsgDuplicateDeptandBand!=null" class="fs-12 red-cl font_regular">{{errMsgDuplicateDeptandBand}}</span>
                  </td>
                  <td colspan="2"><span *ngIf="indexOfErrMsgDuplicateNameandDef==i && errMsgDuplicateNameandDef!=null" class="fs-12 red-cl font_regular">{{errMsgDuplicateNameandDef}}</span></td>
                  <td class="fs-14 font_bold cl-black">Total :<span class="orangecolor">{{getTotalWeight(item)}}</span>
                    <div *ngIf="indexOfErrMsgWtTotal==i && errMsgForTotal!=null" class="fs-12 red-cl font_regular">{{errMsgForTotal}}</div>
                  </td>
                  <td colspan="2">
                    <span *ngIf="indexOfErrMsgDuplicateDeptandBand==i && errMsgDuplicateDeptandBand!=null
                    || indexOfErrMsgDuplicateNameandDef==i && errMsgDuplicateNameandDef!=null ||
                    indexOfErrMsgWtTotal==i && errMsgForTotal!=null" 
                    class="fs-12 red-cl font_regular">Data will not get saved</span>
                  </td>
                  <td colspan="2"></td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ion-row>


      <!-- Manager View  -->
      <ion-row class="p-0 mt-5" *ngIf="selectedTypeTabName == 'Team Competency'">
        <div class="table-container">
          <table class="hover mb-5 custom-table">
            <thead>
              <tr>
                <th class="fs-14 font_bold cl-black top-align">Dept/Function</th>
                <th class="fs-14 font_bold cl-black top-align">{{setupGradeBrand}}</th>
                <th class="fs-14 font_bold cl-black top-align">Competency Name</th>
                <th class="fs-14 font_bold cl-black top-align">Competency Defination</th>
                <th class="fs-14 font_bold cl-black top-align">WT</th>
                <th class="fs-14 font_bold cl-black top-align">Achieved</th>
                <th class="fs-14 font_bold cl-black top-align">Score</th>
                <th class="fs-14 font_bold cl-black top-align">Manager Comment</th>
                <th class="fs-14 font_bold cl-black top-align">Employee Comment</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of competencyListManagerView; let i = index">
                <ng-container *ngFor="let comp of item.competencyMasterlist; let j= index">
                <tr>
                  <td class="fs-14" *ngIf="comp === item.competencyMasterlist[0]" [attr.rowspan]="item.competencyMasterlist.length">{{ item.functionName }}</td>
                  <td class="fs-14" *ngIf="comp === item.competencyMasterlist[0]" [attr.rowspan]="item.competencyMasterlist.length">{{ item.band }}</td>
                  <td class="fs-14">
                  {{ comp.competencyName }}
                  </td>
                  <td class="fs-14">
                    <!-- <div *ngFor="let comp of item.competencyMasterlist; let j = index" class="mb-2"> -->
                      <textarea readonly [(ngModel)]="comp.competencyDefination"
                        class="competency-textarea borderNone"></textarea>
                      <div class="fs-12 font_italic cl-gray">{{ comp.evaluatedRating }}</div>
                    <!-- </div> -->
                  </td>
                  <td class="fs-14" >
                    <!-- <div *ngFor="let comp of item.competencyMasterlist; let j = index" class="mb-2"> -->
                      {{ comp.weightageNo }}
                    <!-- </div> -->
                  </td>
                  <td class="fs-14">
                    <!-- <div *ngFor="let comp of item.competencyMasterlist; let j = index" class="mb-2"> -->
                      <input type="number" [(ngModel)]="comp.achived" (ngModelChange)="updateAchieved(i, j, $event)"
                        (blur)="onBlur(comp, item)" class="achieved-input mt-2" min="0" max="100" maxlength="255"
                        [disabled]="!allowedToEditTeamCompetency" style="width: 70px; text-align: center;" />%
                    <!-- </div> -->
                  </td>
                  <td class="fs-14">
                    <!-- <div *ngFor="let comp of item.competencyMasterlist; let j = index" class="mb-2"> -->
                      {{ (comp.weightageNo * comp.achived / 100) }}
                    <!-- </div> -->
                  </td>
                  <td class="fs-14"  *ngIf="comp === item.competencyMasterlist[0]" [attr.rowspan]="item.competencyMasterlist.length">
                    <textarea (ngModelChange)="checkLengthOfField(item.managerComment)" maxlength="255" [id]="'managerComment-' + i" [(ngModel)]="item.managerComment"
                      (blur)="onBlur(item, item)" rows="2" cols="20" class="comment-textarea"
                      [disabled]="!allowedToEditTeamCompetency" style="width: 100%;"></textarea>
                  </td>
                  <td class="fs-14" *ngIf="comp === item.competencyMasterlist[0]" [attr.rowspan]="item.competencyMasterlist.length">
                    <!-- <div *ngFor="let comp of item.competencyMasterlist; let j = index" class="mb-2"> -->
                      <textarea readonly class="textarea minw190"
                      [(ngModel)]="item.employeeComment"></textarea>
                    <!-- </div> -->
                  </td>
                </tr>
                </ng-container>
                <tr class="total-row">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Evaluated Rating: <span class="orangecolor">{{ item.evaluatedRating }}</span></td>
                  <td>Total WT: <span class="orangecolor">{{ getTotalWeight(item) }}</span></td>
                  <td></td>
                  <td>Total Score: <span class="orangecolor">{{ getTotalScore(item) }}</span></td>
                  <td></td>
                  <td></td>
                </tr>
              <!-- </ng-container> -->
              </ng-container>
            </tbody>
          </table>
        </div>
      </ion-row>



      <!-- My Competency Tab  -->
      <div class="tableCardBox mb-15" *ngIf="selectedTypeTabName == 'My Competency'">
        <ion-row class="p-0 mt-5">
          <div class="table-container" [ngClass]="{'disabled-table': !allowedToEditManagerMycompetency}">
            <table class="hover mb-15">
              <thead>
                <tr>
                  <th class="fs-14 font_bold cl-black">Dept/Function</th>
                  <th class="fs-14 font_bold cl-black">{{setupGradeBrand}}</th>
                  <th class="fs-14 font_bold cl-black">Competency Name</th>
                  <th class="fs-14 font_bold cl-black">Competency Defination</th>
                  <th class="fs-14 font_bold cl-black">WT</th>
                  <th class="fs-14 font_bold cl-black">Achieved</th>
                  <th class="fs-14 font_bold cl-black">Score</th>
                  <th class="fs-14 font_bold cl-black">Manager Comment</th>
                  <th class="fs-14 font_bold cl-black">Employee Comment</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let employee of competencyemployee; let empIndex = index">
                  <ng-container *ngFor="let competency of employee.competencyMasterlist; let i = index">
                    <tr>
                      <ng-container *ngIf="i === 0">
                        <td class="fs-14 font_regular" [attr.rowspan]="employee.competencyMasterlist.length">
                          {{ employee.functionName }}
                        </td>
                        <td class="fs-14 font_regular" [attr.rowspan]="employee.competencyMasterlist.length">
                          {{ employee.band }}
                        </td>
                      </ng-container>
                      <td class="fs-14 font_regular">{{ competency.competencyName }}</td>
                      <td class="fs-14 font_regular">
                        <textarea readonly [(ngModel)]="competency.competencyDefinition"
                        class="competency-textarea borderNone"></textarea></td>
                      <td class="fs-14 font_regular">{{ competency.weightageNo }}</td>
                      <td class="fs-14 font_regular"><span *ngIf="allowedToEditManagerMycompetency">{{ competency.achived }}</span></td>
                      <td class="fs-14 font_regular"><span *ngIf="allowedToEditManagerMycompetency">{{ competency.score | number: '1.0-0' }}</span></td>
                      <ng-container *ngIf="i === 0">
                        <td class="fs-14 font_regular" [attr.rowspan]="employee.competencyMasterlist.length">
                          <span *ngIf="allowedToEditManagerMycompetency">
                            <textarea readonly class="textarea minw190"
                            [(ngModel)]="employee.managerComment"></textarea>
                          </span>
                        </td>
                        <td class="fs-14 font_regular" [attr.rowspan]="employee.competencyMasterlist.length">
                          <div class="comment-box">
                            <ng-container
                              *ngIf="allowedToEditManagerMycompetency">
                              <textarea (ngModelChange)="checkLengthOfField(employee.employeeComment)" maxlength="255" [id]="'employeeComment-' + empIndex" [(ngModel)]="employee.employeeComment"
                                (blur)="updateEmployeeComment(employee, competency)" rows="2" cols="20"
                                class="comment-textarea"></textarea>
                            </ng-container>
                            <!-- <ng-container *ngIf="editedEmployeeCommentIndex !== empIndex">
                              <div class="comment-display">
                                <span (click)="allowedToEditManagerMycompetency && editEmployeeComment(empIndex)">
                                  {{ employee.employeeComment || 'Click to edit' }}
                                </span>
                              </div>
                            </ng-container> -->
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>
                  <tr class="total-row">
                    <td colspan="3" class="fs-14 font_bold cl-black text-right">Evaluated Rating:</td>
                    <td class="fs-12 font_regular bold"><span *ngIf="allowedToEditManagerMycompetency" class="orangecolor">{{ employee.evaluatedRating }}</span>
                    </td>
                    <td class="fs-12 font_regular bold">Total WT: <span class="orangecolor">{{
                        employeetotalweight[empIndex] || 0 }}</span></td>
                    <td></td>
                    <td class="fs-12 font_regular bold">
                      <label *ngIf="allowedToEditManagerMycompetency">Total Score: <span class="orangecolor">{{ employee.totalScore ||
                        0 }}</span></label> </td>
                    <td colspan="3"></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </ion-row>
      </div>


      <!---Employee View --->
      <!-- <div class="tableCardBox mb-15" *ngIf="loggedInUserRole === 'Employee'">
        <ion-row class="p-0 mt-5">
          <div class="table-container">
            <table class="hover mb-15">
              <thead>
                <tr>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      Dept/Function
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      Band/Grade
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      Competency Name
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      Competency Defination
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      WT
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      Achieved
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      Score
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      Manager Comment
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                  <th class="fs-14 font_bold cl-black">
                    <div class="icon-style">
                      Employee Comment
                      <span class="material-icons cp ml-5 mt-3 fs-14">
                        visibility_off
                      </span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let employee of competencyemployee; let index = index">
                  <ng-container *ngFor="let competency of employee.competencyMasterlist; let i = index">
                    <tr>
                      <ng-container *ngIf="i === 0">
                        <td class="fs-14 font_regular" [attr.rowspan]="employee.competencyMasterlist.length">
                          {{ employee.functionName }}
                        </td>
                        <td class="fs-14 font_regular" [attr.rowspan]="employee.competencyMasterlist.length">
                          {{ employee.band }}
                        </td>
                      </ng-container>
                      <td class="fs-14 font_regular">{{ competency.competencyName }}</td>
                      <td class="fs-14 font_regular">{{ competency.competencyDefinition }}</td>
                      <td class="fs-14 font_regular">{{ competency.weightageNo }}</td>
                      <td class="fs-14 font_regular">{{ competency.achived }}</td>

                      <td class="fs-14 font_regular">{{ competency.score || 'No score' }}</td>

                      <ng-container *ngIf="i === 0">
                        <td class="fs-14 font_regular" [attr.rowspan]="employee.competencyMasterlist.length">
                          {{ employee.managerComment || 'No comment' }}
                        </td>
                        <td class="fs-14 font_regular" [attr.rowspan]="employee.competencyMasterlist.length">
                          <div class="comment-box">
                            <ng-container *ngIf="allowedToEditManagerMycompetency">
                              <ng-container *ngIf="editedEmployeeCommentIndex === index">
                                <textarea [id]="'employeeComment-' + index" [(ngModel)]="employee.employeeComment"
                                  (blur)="updateEmployeeComment(employee, competency)" rows="2" cols="20"
                                  class="comment-textarea"></textarea>
                              </ng-container>
                              <ng-container *ngIf="editedEmployeeCommentIndex !== index">
                                <div class="comment-display">
                                  <span (click)="editEmployeeComment(index)">
                                    {{ employee.employeeComment || 'Click to edit' }}
                                  </span>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="!allowedToEditManagerMycompetency">
                              <div class="comment-display">
                                {{ employee.employeeComment || 'No comment' }}
                              </div>
                            </ng-container>
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>
                  <tr class="total-row">
                    <td colspan="4" class="fs-14 font_bold cl-black text-right"></td>
                    <td class="fs-12 font_regular bold">Total WT: <span class="orangecolor">{{
                        employeetotalweight[index] || 0 }}</span></td>
                    <td></td>
                    <td class="fs-12 font_regular bold">Total Score: <span class="orangecolor">{{ employee.totalScore ||
                        0 }}</span></td>
                    <td colspan="3"></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </ion-row>
      </div> -->



      <ion-row class="mb-5">
        <ion-col size="4" class="text-left">
          <ion-label class="fs-14 font_bold black_color">
            Showing {{ endItem!=0?startItem:0 }} to {{ endItem }} of {{ totalItems }} entries
          </ion-label>
        </ion-col>
        <ion-col size="8" class="text-right pagination-controls">
          <div class="center-content">
            <label *ngIf="myCompetencyEvaluatedAt && selectedTypeTabName == 'My Competency'" class="mr-10 fs-14 font_semibold">Evaluated by Manager on {{myCompetencyEvaluatedAt | date:'dd-MM-yyyy | hh:mm a'}}</label>
            <ul class="dt_pagination">
              <ion-row class="float-right pgintn">
                <li class="active fs-16 font_regular">{{totalPages!=0?currentPage+1:0}}</li>
                <span class="fs-14 font_regular p-10">of {{totalPages}}</span>
                <li class="fs-24 cp" (click)="changePage(currentPage - 1)" [ngClass]="{'disableBtn': currentPage === 0}">
                  &lt;</li>
                <li class="fs-24 cp" (click)="changePage(currentPage + 1)"
                  [ngClass]="{'disableBtn': currentPage >= totalPages - 1}">
                  &gt;</li>
              </ion-row>
            </ul>
          </div>
        </ion-col>
      </ion-row>
    </div>
    <div class="clear50"></div>
  </div>


  <!---Setup Popup --->
  <div class="modal fade" [style.display]="showSetupPopup ? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
          <label class="font_semibold fs-18 ml-10 mt-5 black_color">
            <span class="cp" (click)="onClickBreadcrumPMS()">Competency</span> /
            <span [style.color]="buttonColorName">Setup</span>
          </label>
        </div>
        <div class="modal-body p-20">
          <div class="mt-10">
            <div class="cardBox">
              <ion-row>
                <ion-col size="4" class="mt-10">
                  <div class="formLabelRegularfs16 mb-5">
                    Fiscal Year<span class="red-cl">&nbsp;*</span>
                  </div>
                  <div class="inputBoxDisabled">
                    {{ sharedService.transform(loggedInCompanyFiscalyear) }}
                  </div>
                </ion-col>
                <ion-col size="4" class="mt-10">
                  <div class="formLabelRegularfs16 mb-5">
                    Year<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getCompetencySetup()">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="12" class="mt-10">
                  <div class="font_semibold fs-16 mb-5">
                    Choose how you want to map competencies?<span class="red-cl">&nbsp;*</span>
                  </div>
                  <ion-row>
                    <ion-col size="2">
                      <div class="radio-container mt-5 formLabelRegularfs16">
                        <mat-radio-button type="radio" id="band1" name="competencyMapping" value="Band"
                          (click)="restrictToEditSetup || restrictToEditBandOrGrade ? null : logRadioSelection('Band')" [checked]="competencyMapping === 'Band'"
                          [disabled]="restrictToEditBandOrGrade">
                        </mat-radio-button>
                        <ion-text class="formLabelRegularfs16 fs-14">Band</ion-text>
                      </div>
                    </ion-col>
                    <ion-col size="2">
                      <div class="radio-container mt-5 formLabelRegularfs16">
                        <mat-radio-button type="radio" id="band2" name="competencyMapping" value="Grade"
                          (click)="restrictToEditSetup || restrictToEditBandOrGrade ? null : logRadioSelection('Grade')"
                          [checked]="competencyMapping === 'Grade'" [disabled]="restrictToEditBandOrGrade">
                        </mat-radio-button>
                        <ion-text class="formLabelRegularfs16 fs-14">Grade</ion-text>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12" class="mt-10">
                  <div class="font_semibold fs-16 mb-5">
                    Required Rating <span class="red-cl">&nbsp;*</span>
                  </div>
                </ion-col>
                <ion-col size="12" *ngIf="!isLastMaxRange100() && isSelectedYearIsSameYeartoCurrentYear">
                  <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!showInputs" (click)="toggleInputs()"
                    [style.pointer-events]="restrictToEditSetup ? 'none' : 'auto'">
                    + Add New
                  </div>
                </ion-col>
                <ion-col size="12" *ngIf="showInputs">
                  <ion-row>
                    <ion-col size="auto">
                      <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()"
                        [style.pointer-events]="restrictToEditSetup ? 'none' : 'auto'">
                        Save
                      </div>
                    </ion-col>
                    <ion-col size="auto">
                      <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()"
                        [style.pointer-events]="restrictToEditSetup ? 'none' : 'auto'">
                        Remove
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-col>
                <ion-row *ngIf="showInputs" class="mb-15">
                  <ion-col size="4">
                    <div class="w-100 inputBox notAllowed"><span
                      *ngIf="scoreRange!=0">></span>{{scoreRange}}</div>
                    <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <input matInput [(ngModel)]="scoreRange" class="font_regular fs-12" type="number"
                        [required]="showInputs" [attr.disabled]="!showInputs || restrictToEditSetup ? true : null"
                        [value]="scoreRange ? '>' + scoreRange : '>0'" disabled />
                      <mat-error *ngIf="!scoreRange && showInputs">Score Range is required</mat-error>
                    </mat-form-field> -->
                  </ion-col>

                  <ion-col size="4">
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <input matInput [(ngModel)]="maxRange" type="number" placeholder="Max Range"
                        class="font_regular fs-12" min="1"
                        (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                        [attr.disabled]="restrictToEditSetup ? true : null" [required]="showInputs"
                        (keypress)="preventNegative($event)" />
                      <!-- <mat-error ></mat-error> -->
                    </mat-form-field>
                    <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Max Range is required</div>
                    <div *ngIf="!errMsgMaxRange && isInValidMaxRange && showInputs" class="fs-12 red-cl font_regular">Max Range should be greater than Min
                      Range</div>
                  </ion-col>
                  <ion-col size="4">
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <input matInput [(ngModel)]="rating" type="text" placeholder="Rating" class="font_regular fs-12"
                        [attr.disabled]="restrictToEditSetup ? true : null" [required]="showInputs"
                        (ngModelChange)="checkRating($event)" />
                      <!-- <mat-error *ngIf="!rating && showInputs && !isDuplicateRating">Rating is required</mat-error> -->
                    </mat-form-field>
                    <div *ngIf="rating=='' && showInputs" class="fs-12 red-cl font_regular">Rating is required</div>
                  </ion-col>
                </ion-row>
              </ion-row>
              <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="mt-10">
                  <div class="table-container">
                    <table class="custom-table rounded-header">
                      <thead>
                        <tr>
                          <th class="font_semibold fs-14">Score Range</th>
                          <th class="font_semibold fs-14">Rating</th>
                          <th class="font_semibold fs-14 text-center">
                            <div class="delete-icon dFlexCenter"
                              *ngIf="tableData.length != 0 && !restrictToEditSetup && isSelectedYearIsSameYeartoCurrentYear"
                              (click)="deleteSetup()" [style.pointer-events]="restrictToEditSetup ? 'none' : 'auto'">
                              <ion-icon name="trash-outline" class="delete-icon-color"></ion-icon>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngIf="tableData.length === 0">
                          <td colspan="3" class="text-center">No Records</td>
                        </tr>
                        <tr *ngFor="let data of tableData; let i = index">
                          <td>{{ data.scoreRange }} - {{ data.maxRange }}</td>
                          <td>{{ data.rating }}</td>
                          <td>
                            <!-- Add row-specific actions if needed -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                      {{ errorMessage }}
                    </div>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12" class="mt-10">
                  <div class="font_semibold fs-16 mb-5">
                    How many months before competency evaluation to start? <span class="red-cl">&nbsp;*</span>
                    <div class="hover-text">
                      <ion-icon name="information-circle-outline" class="info-icon"></ion-icon>
                      <span class="tooltip-text" id="right">How many months before the fiscal year end, should the
                        competency sheet be opened to a manager to start rating employee?</span>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="2" class="mt-10">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="evaluationPeriod"
                      (ngModelChange)="logEvaluationPeriod()"
                      [disabled]="restrictToEditSetup || !isSelectedYearIsSameYeartoCurrentYear">
                      <mat-option *ngFor="let item of numbersOfDaysArray" [value]="item">{{ item }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </div>
          </div>
          <div class="mt-10">
            <button type="button" class="back_btn mr-10" (click)="onClickBreadcrumPMS()">Back</button>
            <button type="button" class="add_btn fs-14 mr-10" [ngClass]="{
              'disabled-button': (restrictToEditSetup || !isSelectedYearIsSameYeartoCurrentYear),
              'enabled-button': (!(restrictToEditSetup || !isLastMaxRange100()) && isSelectedYearIsSameYeartoCurrentYear)
            }" (click)="handleSubmit()"
              [disabled]="restrictToEditSetup || !isSelectedYearIsSameYeartoCurrentYear">
              Save
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>




  <!-- --------------------------------------Reports--------------------------------- -->

  <div class="container" *ngIf="selectedTypeTabName == 'Reports'">
    <ion-row class="pl-0 pt-5 pb-5 pr-5">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-0 pt-5 pb-5 pr-5">
        <div class="d-flex">
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="pl-0 pt-5 pb-5 pr-5">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="pl-0 pt-5 pb-5 pr-5">
        <!-- hr admin -->
        <div class="" *ngIf="selectedTypeTabName == 'Reports' && (loggedInUserRole == 'HR Admin' ||  loggedInUserRole == 'Super Admin' || 
        loggedInUserRole == 'MD' ||  loggedInUserRole == 'PHI Admin' )">
          <ion-row class="p-0">
            <mat-form-field class="w150 mat-height40 mat-input-style">
              <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForCompetency"
                (selectionChange)="onSelectYearForCompetencyForOther()">
                <mat-option [value]="item.year"
                  *ngFor="let item of compentencySetupYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>

            <ng-multiselect-dropdown *ngIf="loggedInUserRole != 'Employee'" class="ml-5 w250"
              [placeholder]="'Dept/Function'" [settings]="dropdownSettings" [data]="getListOfDepartmentsOfComp"
              [(ngModel)]="selectedFunctionsForHrAdmin" (onSelect)="onItemSelect($event)"
              (onDeSelect)="onItemDeselect($event)" (onSelectAll)="onSelectAll($event)"
              (onDeSelectAll)="onDeselectAll($event)">
            </ng-multiselect-dropdown>

            <ng-multiselect-dropdown *ngIf="loggedInUserRole != 'Employee'" class="ml-5 w250"
              [placeholder]="setupGradeBrand" [settings]="dropdownSettings" [data]="bandListHrAdmin"
              [(ngModel)]="selectedBands" (onSelect)="onBandSelect($event)" (onDeSelect)="onBandDeSelect($event)"
              (onSelectAll)="onBandSelectAll($event)" (onDeSelectAll)="onBandDeSelectAll($event)">
            </ng-multiselect-dropdown>

            <ng-multiselect-dropdown *ngIf="loggedInUserRole != 'Employee'" class="ml-5 w250"
              [placeholder]="'Select Employees'" [data]="employeeList" [settings]="dropdownSettings"
              [(ngModel)]="selectedEmployees" (onSelect)="onEmployeeSelect($event)"
              (onDeSelect)="onEmployeeDeselect($event)" (onSelectAll)="onSelectAllEmployees($event)"
              (onDeSelectAll)="onDeselectAllEmployees($event)">
            </ng-multiselect-dropdown>

            <button type="button" class="add_btn fs-14 ml-5" [style.background-color]="buttonColorName"
              (click)="submitData()">
              Submit</button>
            <div class="center-content ml-15" *ngIf="loggedInUserRole != 'Employee'">
              <u class="cp link font_regular fs-12" (click)="clearFilter()">Clear Filter</u>
            </div>
          </ion-row>
        </div>

        <!-- Manager Login -->
        <div class="" *ngIf="selectedTypeTabName == 'Reports' && (loggedInUserRole == 'Manager' ||  loggedInUserRole == 'HOD')">
          <ion-row class="p-0">
            <mat-form-field class="w150 mat-height40 mat-input-style">
              <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForCompetency"
                (selectionChange)="onSelectYearForCompetencyForOther()">
                <mat-option [value]="item.year"
                  *ngFor="let item of compentencySetupYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Dept/Function'" [settings]="dropdownSettings"
              [data]="managerFunctionsList" [(ngModel)]="selectedManagerFunctions"
              (onSelect)="onManagerItemSelect($event)" (onDeSelect)="onManagerItemDeselect($event)"
              (onSelectAll)="onManagerSelectAll($event)" (onDeSelectAll)="onManagerDeselectAll($event)">
            </ng-multiselect-dropdown>

            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Band'" [settings]="dropdownSettings"
              [data]="bandListHrAdmin" [(ngModel)]="selectedBands" (onSelect)="onManagerBandSelected($event)"
              (onDeSelect)="onManagerBandDeSelected($event)" (onSelectAll)="onManagerSelectAllBands($event)"
              (onDeSelectAll)="onManagerDeSelectAllBands($event)">
            </ng-multiselect-dropdown>

            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select Employees'" [settings]="dropdownSettings"
              [data]="employeeList" [(ngModel)]="selectedEmployeesManager"
              (onSelect)="onManagerEmployeeListSelect($event)" (onDeSelect)="onManagerEmployeeListDeselect($event)"
              (onSelectAll)="onManagerSelectAllEmployees($event)"
              (onDeSelectAll)="onManagerDeselectAllEmployees($event)">
            </ng-multiselect-dropdown>

            <button type="button"
              class="add_btn fs-14 ml-5" [style.background-color]="buttonColorName" (click)="submitManagerDataReport()">
              Submit</button>
            <div class="center-content ml-15">
              <u class="cp link" (click)="clearFilterManager()">Clear Filter</u>
            </div>
          </ion-row>
        </div>

        <!--Employee Login-->
        <div class="" *ngIf="selectedTypeTabName == 'Reports' && loggedInUserRole == 'Employee'">
          <ion-row class="p-0">
            <mat-form-field class="w150 mat-height40 mat-input-style">
              <mat-select placeholder="FY Year" [(ngModel)]="selectedYearForCompetency"
                (selectionChange)="onSelectYearForCompetencyForOther()">
                <mat-option [value]="item.year"
                  *ngFor="let item of compentencySetupYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
            <button type="button" class="add_btn fs-14 ml-5" [style.background-color]="buttonColorName"
              (click)="submitEmployeeReportData()">
              Submit
            </button>
            <div class="center-content ml-15">
            </div>
          </ion-row>
        </div>
      </ion-col>
    </ion-row>



    <div class="tableCardBox mb-15 mt-10">
      <ion-row class="p-0 mt-5">
        <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="d-flex">
          <mat-form-field *ngIf="!anyItemSelected" class="mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchStringReport"
              (input)="onSearchReport(searchStringReport)">
          </mat-form-field>
          <ion-label class="fs-14 ml-10 mt-10 font_medium text-center black_color">Show</ion-label>
          <mat-form-field class="w-15 ml-10 mat-height40 mat-input-style">
            <mat-select placeholder="Select" [(ngModel)]="selectedSizeOfReport"
              (selectionChange)="onSelectSizeOfCompetencyReport()">
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="fs-14 ml-10 mt-10 font_medium black_color">entries</ion-label>
        </ion-col>
        <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
          <div class="button-container mb-10">
            <!-- PDF EXCEL Buttons for HR Admin -->
            <div *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' 
            || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD'" class="d-flex">
              <button (click)="downloadReportHrAdminExcel()" title="Download Excel" type="button"
                class="imageIcon center-content fs-14"><span class="ml-5 mr-5 fs-20 material-icons">download</span><span
                  class="mr-10">Excel</span></button>
              <button (click)="downloadReportHrAdmin()" title="Download PDF"
                type="button" class="imageIcon center-content fs-14 ml-5"><span
                  class="ml-5 mr-5 fs-20 material-icons">download</span><span class="mr-10">Pdf</span></button>
            </div>
  
            <!-- PDF EXCEL Buttons for Manager -->
            <div *ngIf="loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD'" class="d-flex">
              <button (click)="downloadReportManagerExcel()" title="Download Excel" type="button"
                class="imageIcon center-content fs-14"><span class="ml-5 mr-5 fs-20 material-icons">download</span><span
                  class="mr-10">Excel</span></button>
              <button (click)="downloadReportManagerPdf()" title="Download PDF"
                type="button" class="imageIcon center-content fs-14 ml-5"><span
                  class="ml-5 mr-5 fs-20 material-icons">download</span><span class="mr-10">Pdf</span></button>
            </div>
  
            <!-- PDF EXCEL Buttons for Employee -->
            <div *ngIf="loggedInUserRole === 'Employee'" class="d-flex float-right">
              <button (click)="downloadReportEmployeeExcel()" title="Download Excel" type="button"
                class="imageIcon center-content fs-14"><span class="ml-5 mr-5 fs-20 material-icons">download</span><span
                  class="mr-10">Excel</span></button>
              <button (click)="downloadReportEmployeePdf()" title="Download PDF"
                type="button" class="imageIcon center-content fs-14 ml-5"><span
                  class="ml-5 mr-5 fs-20 material-icons">download</span><span class="mr-10">Pdf</span></button>
            </div>
          </div>
        </ion-col>
      </ion-row>

        <div class="table-container p-3">
          <table class="hover mb-15">
            <thead>
              <tr>
                <th class="fs-14 font_bold cl-black">Employee Name</th>
                <th class="fs-14 font_bold cl-black">Manager Name</th>
                <th class="fs-14 font_bold cl-black">{{setupGradeBrand}}</th>
                <th class="fs-14 font_bold cl-black">Dept/Function</th>
                <th class="fs-14 font_bold cl-black">Competency Name</th>
                <th class="fs-14 font_bold cl-black">Competency Defination</th>
                <th class="fs-14 font_bold cl-black">WT</th>
                <th class="fs-14 font_bold cl-black">Achieved</th>
                <th class="fs-14 font_bold cl-black">Score</th>
                <th class="fs-14 font_bold cl-black">Manager Comment</th>
                <th class="fs-14 font_bold cl-black">Employee Comment</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let reportItem of reportDataList">
                <ng-container
                  *ngFor="let competency of reportItem.competencyMasterlist; let last = last; let i = index">
                  <tr>
                    <td class="fs-14 font_regular" [attr.rowspan]="reportItem.competencyMasterlist.length"
                      *ngIf="i === 0">
                      {{ reportItem.employeeName }}
                    </td>
                    <td class="fs-14 font_regular" [attr.rowspan]="reportItem.competencyMasterlist.length"
                      *ngIf="i === 0">
                      {{ reportItem.managerName }}
                    </td>
                    <td class="fs-14 font_regular" [attr.rowspan]="reportItem.competencyMasterlist.length"
                      *ngIf="i === 0">
                      {{ reportItem.band }}
                    </td>
                    <td class="fs-14 font_regular" [attr.rowspan]="reportItem.competencyMasterlist.length"
                      *ngIf="i === 0">
                      {{ reportItem.functionName }}
                    </td>
                    <td class="fs-14 font_regular">{{ competency.competencyName }}</td>
                    <td class="fs-14 font_regular">
                      <textarea readonly [(ngModel)]="competency.competencyDefination"
                      class="competency-textarea borderNone"></textarea></td>
                    <td class="fs-14 font_regular">{{ competency.weightageNo }}</td>
                    <td class="fs-14 font_regular">
                      <span *ngIf="allowedToEditManagerMycompetency && loggedInUserRole=='Employee'">{{ competency.achived }}</span>
                      <span *ngIf="loggedInUserRole!='Employee'">{{ competency.achived }}</span>
                    </td>
                    <td class="fs-14 font_regular">
                      <span *ngIf="allowedToEditManagerMycompetency && loggedInUserRole=='Employee'">{{ calculateScore(competency.weightageNo, competency.achived) }}</span>
                      <span *ngIf="loggedInUserRole!='Employee'">{{ calculateScore(competency.weightageNo, competency.achived) }}</span>
                    </td>
                    <td class="fs-14 font_regular" [attr.rowspan]="reportItem.competencyMasterlist.length"
                      *ngIf="i === 0">
                      <textarea readonly [rows]="reportItem.competencyMasterlist.length+2" class="textarea minw190"
                          [(ngModel)]="reportItem.managerComment"></textarea>
                      <!-- {{ reportItem.managerComment }} -->
                    </td>
                    <td class="fs-14 font_regular" [attr.rowspan]="reportItem.competencyMasterlist.length"
                      *ngIf="i === 0">
                      <textarea readonly [rows]="reportItem.competencyMasterlist.length+2" class="textarea minw190"
                          [(ngModel)]="reportItem.employeeComment"></textarea>
                    </td>
                  </tr>
                  <!-- Totals row -->
                  <tr *ngIf="last" class="total-row">
                    <td colspan="5" class="fs-14 font_bold cl-black text-right"></td>
                    <td class="fs-12 font_regular bold">
                      <span *ngIf="allowedToEditManagerMycompetency && loggedInUserRole=='Employee'">
                        Evaluated Rating: <span class="orangecolor">{{ reportItem.evaluatedRating || '' }}</span>
                      </span>
                      <span *ngIf="loggedInUserRole!='Employee'">
                        Evaluated Rating: <span class="orangecolor">{{ reportItem.evaluatedRating || '' }}</span>
                      </span>
                    </td>
                    <td class="fs-12 font_regular bold">
                      Total WT: <span class="orangecolor">{{
                        getTotalWeightForCompetency(reportItem.competencyMasterlist) }}</span>
                    </td>
                    <td></td> <!-- Empty cell for "Achieve" column -->
                    <td class="fs-12 font_regular bold">
                      <span *ngIf="allowedToEditManagerMycompetency && loggedInUserRole=='Employee'">
                        Total Score: <span class="orangecolor">{{
                          getTotalScoreForCompetency(reportItem.competencyMasterlist) }}</span>
                      </span>
                      <span *ngIf="loggedInUserRole!='Employee'">
                        Total Score: <span class="orangecolor">{{
                          getTotalScoreForCompetency(reportItem.competencyMasterlist) }}</span>
                      </span>
                    </td>
                    <td colspan="2"></td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>

        <ion-row class="mb-5">
          <ion-col size="4" class="text-left">
            <ion-label class="fs-14 font_bold black_color">
              Showing {{ endItem!=0?startItem:0 }} to {{ endItem }} of {{ totalItems }} entries
            </ion-label>
          </ion-col>
          <ion-col size="8" class="text-right pagination-controls">
            <div class="center-content">
              <ul class="dt_pagination">
                <ion-row class="float-right pgintn">
                  <li class="active fs-16 font_regular">{{totalPages!=0?currentPage+1:0}}</li>
                  <span class="fs-14 font_regular p-10">of {{totalPages}}</span>
                  <li class="fs-24 cp" (click)="changePage(currentPage - 1)" [ngClass]="{'disableBtn': currentPage === 0}">
                    &lt;</li>
                  <li class="fs-24 cp" (click)="changePage(currentPage + 1)"
                    [ngClass]="{'disableBtn': currentPage >= totalPages - 1}">
                    &gt;</li>
                </ion-row>
              </ul>
            </div>
          </ion-col>
        </ion-row>
    </div>

  </div>
</ion-content>